/**
 * @generated SignedSource<<daad9699ca3349ebb08cf89236fa36f3>>
 * @relayHash f692d44d844dd3d841fca6e696af1a23
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bc079687d58a2915d24ae9cd5532c282b6a3bd766f81e26500ec1cf9dbbc4a79

import type { ConcreteRequest } from 'relay-runtime';
export type utils_CurrentUser_Query$variables = Record<PropertyKey, never>;
export type utils_CurrentUser_Query$data = {
  readonly me: {
    readonly user: {
      readonly accountId?: string;
      readonly email?: string | null;
      readonly id?: string;
      readonly name?: string;
      readonly nickname?: string | null;
      readonly picture?: AGG$URL;
    } | null;
  };
};
export type utils_CurrentUser_Query = {
  response: utils_CurrentUser_Query$data;
  variables: utils_CurrentUser_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "nickname"
},
v4 = {
  "kind": "ScalarField",
  "name": "picture"
},
v5 = {
  "kind": "ScalarField",
  "name": "email"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "utils_CurrentUser_Query",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "type": "AtlassianAccountUser"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "utils_CurrentUser_Query",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v0/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "type": "AtlassianAccountUser"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "bc079687d58a2915d24ae9cd5532c282b6a3bd766f81e26500ec1cf9dbbc4a79",
    "metadata": {},
    "name": "utils_CurrentUser_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d5d3e1d1765f7f226499e9259daca3cb";

export default node;
